import React, { useState } from 'react';

export interface TabDef {
  id: string;
  heading?: React.ReactNode;
  label?: string;
  content: React.ReactNode;
  disabled?: boolean;
  testId?: string;
}

interface TabsProps {
  tabs: TabDef[];
  defaultTab?: string;
  activeTab?: string;
  onTabChange?: (id: string) => void;
  scrollContent?: boolean;
  testId?: string;
}

const toKebab = (s: string) =>
  s.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

export function Tabs({ tabs, defaultTab, activeTab, onTabChange, scrollContent, testId }: TabsProps) {
  const [internalId, setInternalId] = useState(defaultTab ?? tabs.find(t => !t.disabled)?.id ?? tabs[0]?.id);
  const activeId = activeTab ?? internalId;
  const setActiveId = (id: string) => { setInternalId(id); onTabChange?.(id); };
  const active = tabs.find(t => t.id === activeId) ?? tabs[0];

  return (
    <div style={scrollContent ? { display: 'flex', flexDirection: 'column', height: '100%' } : undefined} data-testid={testId}>
      <ul className="nav nav-tabs" style={scrollContent ? { flexShrink: 0 } : undefined}>
        {tabs.map(tab => (
          <li key={tab.id} className={[tab.id === active?.id ? 'active' : '', tab.disabled ? 'disabled' : ''].filter(Boolean).join(' ')}>
            <a
              role="tab"
              data-testid={tab.testId ?? `tab-${toKebab(tab.id)}`}
              onClick={e => { e.preventDefault(); if (!tab.disabled) setActiveId(tab.id); }}
              aria-disabled={tab.disabled}
            >
              {tab.heading ?? tab.label}
            </a>
          </li>
        ))}
      </ul>
      <div className="tab-content" style={scrollContent ? { flex: 1, overflowY: 'auto', minHeight: 0 } : undefined}>
        {active?.content}
      </div>
    </div>
  );
}
